import React from "react";
import UniversityProgramPageSection from "../../Sections/UniversityProgramPageSection/Content";
const UniversityProgramPage = () => {
  return <UniversityProgramPageSection />;
};

export default UniversityProgramPage;
